import { useOffline } from "@/hooks/useOffline";
import { WifiSlash, CloudArrowUp } from "@phosphor-icons/react";

export default function OfflineBanner() {
  const { online, pending, forceFlush } = useOffline();

  if (online && pending === 0) return null;

  return (
    <div
      className={`px-3 py-2 text-xs flex items-center gap-2 border-b ${
        online
          ? "bg-[#005CFF]/15 border-[#005CFF]/30 text-[#5BA3FF]"
          : "bg-amber-500/15 border-amber-500/30 text-amber-300"
      }`}
      data-testid="offline-banner"
    >
      {online ? <CloudArrowUp size={14} weight="bold" /> : <WifiSlash size={14} weight="bold" />}
      <div className="flex-1">
        {online
          ? `Synchronisation — ${pending} action${pending > 1 ? "s" : ""} en attente`
          : `Hors ligne — ${pending} action${pending > 1 ? "s" : ""} en attente${pending > 0 ? "" : ", vos actions seront sauvegardées"}`}
      </div>
      {online && pending > 0 && (
        <button onClick={forceFlush} className="text-[10px] uppercase tracking-widest font-semibold" data-testid="force-sync-btn">
          Synchroniser
        </button>
      )}
    </div>
  );
}
